import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, Select, Spin } from "antd";
import GoogleImage from "../../assets/images/google-icon.svg";
import AppleImage from "../../assets/images/apple-icon.svg";
import { useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
import PhoneInput from "react-phone-input-2";
import {
  generateUniqueCustomerToken,
  getSystemInfo,
  uPayments,
} from "../../helper/functions";
import { getDeviceId } from "../../helper/functions";
import { Severty, ShowToast } from "../../helper/toast";
import { requestFcmToken } from "../../config/firebase";

const SignupForm = () => {
  const [form] = Form.useForm();
  const {
    signup,
    loading,
    generateOtp,
    sentSMS,
    googleSignIn,
    appleSignIn,
    firebaseAuth,
  } = useAuth();
  const Navigate = useNavigate();
  const [systemInfo, setSystemInfo] = useState(null);
  const [inputType, setInputType] = useState("email");
  const [countryCode, setCountryCode] = useState("");
  const onFinish = async (values) => {
    try {
      const deviceId = getDeviceId();
      const customerUniqueToken = await generateUniqueCustomerToken();
      const createCustomerTokenOnUPayments = await uPayments(
        customerUniqueToken
      );

      values.customerUniqueToken = customerUniqueToken;
      values.email = values.email?.toLowerCase();
      values.device_id = deviceId;
      let signupData = { ...values };
      // If phone number is selected, format the data properly
      // if (inputType === "phone" && values.phone) {
      //   let phoneNumber = values.phone;
      //   let countryCode, number;

      //   if (phoneNumber.length == 12) {
      //     countryCode = phoneNumber.substring(0, 2);
      //     number = phoneNumber.substring(2);
      //   } else if (phoneNumber.length == 13) {
      //     countryCode = phoneNumber.substring(0, 3);
      //     number = phoneNumber.substring(3);
      //   } else if (phoneNumber.length == 11) {
      //     countryCode = phoneNumber.substring(0, 1);
      //     number = phoneNumber.substring(1);
      //   }

      //   signupData = {
      //     ...values,
      //     phone: number,
      //     countryCode: `+${countryCode}`,
      //   };
      // }

      if (inputType === "phone" && values.phone) {
        signupData = {
          ...values,
          phone: values.phone.slice(countryCode.length),
          countryCode: countryCode,
        };
      }
      const result = await signup(signupData);
      // --------------- Sent Otp on email of phone number ----------------
      let sentOtp;
      if (result.success) {
        if (inputType === "email") {
          sentOtp = await generateOtp({ email: signupData.email });
          ShowToast(sentOtp.message, Severty.SUCCESS);
          // console.log("sent otp --->", sentOtp);
          if (sentOtp.status === 200) {
            Navigate("/otp", {
              state: {
                data: { email: signupData.email, type: "signup" },
              },
            });
          }
        } else {
          sentOtp = await generateOtp({
            phone: signupData.phone,
            countryCode: signupData.countryCode,
          });
          ShowToast(
            `${sentOtp.message} OTP - ${sentOtp.data.otp}`,
            Severty.SUCCESS
          );
          // here to otp sent on phone number
          const smsData = {
            phone: signupData.phone,
            countryCode: signupData.countryCode,
            otp: sentOtp.data.otp,
          };
          await sentSMS(smsData);
          Navigate("/otp", {
            state: {
              data: {
                phone: signupData.phone,
                countryCode: signupData.countryCode,
                type: "signup",
              },
            },
          });
        }
      }

      // if (result.success) {
      //   Navigate("/home");
      // }
    } catch (error) {
      console.error("Signup error:", error);
    }
  };

  const signInWithGoogle = async () => {
    const deviceId = getDeviceId();
    const fcmToken = await requestFcmToken();
    const customerUniqueToken = await generateUniqueCustomerToken();
    const result = await googleSignIn();

    const userData = {
      firebaseToken: result.user.accessToken,
      device_id: deviceId,
      device_name: systemInfo?.deviceName,
      device_type: "browser",
      deviceToken: fcmToken ? fcmToken : "",
      platform: systemInfo?.platform,
      customerUniqueToken: customerUniqueToken,
      location: systemInfo?.location ?? {
        city: "Dubai",
        country: "UAE",
        country_code: "AE",
        latitude: 25.2048,
        longitude: 55.2708,
      },
    };

    if (result.success) {
      const response = await firebaseAuth(userData);
      if (response.success) {
        Navigate("/home");
      }
    }
  };

  const signInWithApple = async () => {
    try {
      const result = await appleSignIn();
    } catch (error) {
      console.log("Error occured while signing in with Apple:", error);
    }
  };

  const fetchSystemDetails = async () => {
    const systemInfo = await getSystemInfo();
    setSystemInfo(systemInfo);
  };

  useEffect(() => {
    fetchSystemDetails();
  }, []);

  return (
    <div className="signup-container">
      <div className="signup-box">
        <h4 className="signup-title">Create an Account</h4>
        <p className="signup-subtitle">Sign up to continue</p>

        <div className="social-buttons">
          <Button className="social-btn" onClick={signInWithGoogle}>
            <img src={GoogleImage} />
            Google
          </Button>
          <Button className="social-btn" onClick={signInWithApple}>
            <img src={AppleImage} />
            Apple
          </Button>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          requiredMark={false}
        >
          <div className="social-buttons">
            <Button
              className={`social-btn social-btn-mainjj ${
                inputType === "email" ? "phone-login-active" : ""
              }`}
              onClick={() => setInputType("email")}
            >
              Email
            </Button>
            <Button
              className={`social-btn social-btn-mainjj ${
                inputType === "phone" ? "phone-login-active" : ""
              }`}
              onClick={() => setInputType("phone")}
            >
              Phone Number
            </Button>
          </div>

          <Form.Item
            name="name"
            rules={[
              { required: true, message: "Please enter your name" },
              {
                validator: (_, value) => {
                  if (value && value.trim() !== "") {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Name cannot be empty or just spaces")
                  );
                },
              },
            ]}
          >
            <Input className="signup-input" placeholder="Name" />
          </Form.Item>

          {inputType === "email" ? (
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input placeholder="Email" />
            </Form.Item>
          ) : (
            <Form.Item
              name="phone"
              rules={[
                { required: true, message: "Please enter your phone number" },
              ]}
            >
              <PhoneInput
                country="kw"
                enableSearch
                value={form.getFieldValue("phone")}
                onChange={(value, country) => {
                  setCountryCode(country.dialCode);
                  form.setFieldsValue({ phone: value });
                }}
                inputStyle={{
                  width: "100%",
                  height: "57px",
                  borderRadius: "12px",
                  background: "transparent",
                  color: "white",
                  border: "none",
                  fontSize: "16px",
                }}
              />
            </Form.Item>
          )}
          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Please enter your password" },
              { min: 6, message: "Password must be at least 6 characters" },
              {
                validator: (_, value) => {
                  if (!value || value.trim() === "") {
                    return Promise.reject(
                      new Error("Password cannot be empty or just spaces")
                    );
                  }

                  // strong password regex
                  const strongPasswordRegex =
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{6,}$/;

                  if (!strongPasswordRegex.test(value)) {
                    return Promise.reject(
                      new Error(
                        "Password must include uppercase, lowercase, number, and special character"
                      )
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input.Password className="signup-input" placeholder="Password" />
          </Form.Item>
          <Form.Item
            name="gamingPlateForm"
            rules={[
              { required: true, message: "Please select your gaming platform" },
            ]}
          >
            <Select
              placeholder="Select Gaming Platform"
              className="sign-up-selector"
            >
              <Select.Option value="pc">PC</Select.Option>
              <Select.Option value="xbox">Xbox</Select.Option>
              <Select.Option value="playstation">PlayStation</Select.Option>
              <Select.Option value="mobile">Mobile</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="agreement"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject("You must agree to the terms"),
              },
            ]}
          >
            <Checkbox className="trems-and-condition-form">
              I agree to the{" "}
              <span
                className="for-colorrr"
                onClick={() => Navigate("/terms-and-condition")}
              >
                Terms of Service
              </span>{" "}
              and{" "}
              <span
                className="for-colorrr"
                onClick={() => Navigate("/privecy-policy")}
                style={{ cursor: "pointer" }}
              >
                Privacy Policy
              </span>
            </Checkbox>
          </Form.Item>

          <Form.Item>
            <Button
              className="Fill-button"
              htmlType="submit"
              // disabled={loading}
            >
              {loading ? <Spin size="small" /> : "Sign Up"}
            </Button>
          </Form.Item>

          <div className="signin-text">
            Already have an account?{" "}
            <span onClick={() => Navigate("/sign-in")}>Sign In</span>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default SignupForm;
